import Cookies from 'js-cookie';

export const popup = ($popups) => {
    $popups.each((i, p) => {
        let $p = $(p);
        const id = $p.data('popup-id');
        $p.find('.popup-pp__close').click(e => {
            e.preventDefault();
            e.stopImmediatePropagation();

            $p.fadeOut();
            if ($p.data('only-once') == '1') {
                Cookies.set('popup-pp-' + id, '1');
            }
        });
    });
};
